var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 207",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2440,-200)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1,40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_2.svg",
    transform: "matrix(1,0,0,1,2591,290)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-250,-250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.443,202.536C296.245,214.589 275,220.521 264.339,222.859C278.365,216.422 294.031,205.224 306.99,185.896C306.99,185.891 311.688,191.203 308.443,202.536Z",
    style: {
      fill: "rgb(13,202,240)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.099,246.453C161.099,246.453 174.661,210.115 204.047,205.891C233.432,201.667 238.516,213.776 271.578,201.948C271.578,201.948 277.224,219.693 241.911,224.198C241.911,224.198 238.234,231.24 249.255,231.24C260.276,231.24 299.266,226.333 326.391,185.885C326.391,185.885 339.104,200.255 308.307,232.083C277.516,263.911 238.521,280.26 161.099,246.453Z",
    style: {
      fill: "rgb(13,202,240)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.323,144.849C274.719,139.26 265.635,139.26 260.026,144.849L252.474,152.375L244.922,144.849C239.318,139.26 230.229,139.26 224.63,144.849C221.823,147.646 220.427,151.302 220.427,154.964C220.427,158.625 221.828,162.286 224.63,165.083L252.479,192.849L252.484,192.849L280.333,165.083C285.932,159.495 285.932,150.432 280.323,144.849ZM262.734,170.542L256.271,170.542L256.271,176.984L248.667,176.984L248.667,170.542L242.208,170.542L242.208,162.964L248.667,162.964L248.667,156.521L256.271,156.521L256.271,162.964L262.734,162.964L262.734,170.542Z",
    style: {
      fill: "rgb(226,64,101)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105.868,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.896,-24.021L27.896,0L22.063,0L22.063,-16.229L15.021,-6.833L8.146,-16.208L8.146,0L2.563,0L2.563,-24.021L8.5,-24.021L15.229,-14.646L22.104,-24.021L27.896,-24.021Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,136.324,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.688,-10.292L15.688,0L9.854,0L9.854,-10.396L0.75,-24.021L7.917,-24.021L13.354,-14.896L18.292,-24.021L24.083,-24.021L15.688,-10.292Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,161.236,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.563,-24.021L8.396,-24.021L8.396,-14.292L17.208,-14.292L17.208,-24.021L23,-24.021L23,0L17.208,0L17.208,-9.542L8.396,-9.542L8.396,0L2.563,0L2.563,-24.021Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,186.796,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.563,-24.021L19,-24.021L19,-19.521L8.396,-19.521L8.396,-14.292L17.604,-14.292L17.604,-9.75L8.396,-9.75L8.396,-4.5L19,-4.5L19,0L2.563,0L2.563,-24.021Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,208.144,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.667,-5.187L7.708,-5.187L5.979,0L0.458,0L9.542,-24.021L15.917,-24.021L24.417,0L18.438,0L16.667,-5.187ZM15.229,-9.458L12.167,-18.542L9.146,-9.458L15.229,-9.458Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,233.02,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.563,-24.021L8.396,-24.021L8.396,-4.562L18.833,-4.562L18.833,0L2.563,0L2.563,-24.021Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,253,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.604,-19.521L0.854,-19.521L0.854,-24.021L20.271,-24.021L20.271,-19.521L13.438,-19.521L13.438,0L7.604,0L7.604,-19.521Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,274.132,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.563,-24.021L8.396,-24.021L8.396,-14.292L17.208,-14.292L17.208,-24.021L23,-24.021L23,0L17.208,0L17.208,-9.542L8.396,-9.542L8.396,0L2.563,0L2.563,-24.021Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,299.692,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.167,0.458C5.302,0.458 1.375,-3.687 1.375,-11.979C1.375,-20.354 5.302,-24.542 13.167,-24.542C15.594,-24.542 18.146,-23.958 20.813,-22.792L20.813,-17.708C18.505,-19.25 16.219,-20.021 13.958,-20.021C11.75,-20.021 10.094,-19.401 9,-18.167C7.917,-16.927 7.375,-14.865 7.375,-11.979C7.375,-9.104 7.927,-7.062 9.042,-5.854C10.167,-4.656 11.896,-4.062 14.229,-4.062C15.188,-4.062 16.229,-4.24 17.354,-4.604C18.479,-4.964 19.63,-5.526 20.813,-6.292L20.813,-1.229C19.823,-0.714 18.625,-0.302 17.208,0C15.792,0.302 14.443,0.458 13.167,0.458Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,322.372,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.667,-5.187L7.708,-5.187L5.979,0L0.458,0L9.542,-24.021L15.917,-24.021L24.417,0L18.438,0L16.667,-5.187ZM15.229,-9.458L12.167,-18.542L9.146,-9.458L15.229,-9.458Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,347.248,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.75,0L11.979,-8.271L8.396,-8.271L8.396,0L2.563,0L2.563,-24.021L14.25,-24.021C17.01,-24.021 19.151,-23.38 20.667,-22.104C22.177,-20.823 22.938,-18.927 22.938,-16.417C22.938,-14.859 22.5,-13.417 21.625,-12.083C20.76,-10.75 19.568,-9.854 18.042,-9.396L24.146,0L16.75,0ZM13.292,-12.562C15.51,-12.562 16.625,-13.75 16.625,-16.125C16.625,-17.234 16.359,-18.073 15.833,-18.646C15.302,-19.229 14.542,-19.521 13.542,-19.521L8.396,-19.521L8.396,-12.562L13.292,-12.562Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,372.772,312.936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.563,-24.021L19,-24.021L19,-19.521L8.396,-19.521L8.396,-14.292L17.604,-14.292L17.604,-9.75L8.396,-9.75L8.396,-4.5L19,-4.5L19,0L2.563,0L2.563,-24.021Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo_2.a2d22179d4254b45a9b61cacc4744e64.svg";
export { ForwardRef as ReactComponent };